let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("aMHHh")).then(() => parcelRequire('4zqO5'));